<template>
    <div class="container text-center mt-3">
        <transition name="fade" mode="out-in">
            <div key="reported" v-if="this.username" class="row">
                <div class="container col-sm-6 pt-5">
                    <div class="mb-3">
                        <div class="mb-5">
                            <h1 v-if="this.started">Witaj, {{ username }}</h1>
                            <h1 v-else>Żegnaj, {{ username }}</h1>
                        </div>

                        <h2 v-if="this.started">Rozpoczęcie pracy:</h2>
                        <h2 v-else>Zakończenie pracy:</h2>

                        <h2>{{ displayTime() }}</h2>
                    </div>
                </div>
            </div>
            <div key="ready" v-else>
                <HiddenInput @inputConfirmed="report"></HiddenInput>
                <div>
                    <h2>Przyłóż swoją kartę do czytnika</h2>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import {backend} from "../../backend";
    import moment from "moment";

    import HiddenInput from "../HiddenInput.vue"

    moment.locale('pl');

    export default {
        name: "RfidLogin",
        components: {HiddenInput},
        data() {
            return {
                username: '',
                minutes: null,
                started: null,
            }
        },
        methods: {
            reset() {
                this.username = '';
                this.minutes = null;
                this.started = null;
            },
            displayTime() {
                return moment.utc().startOf('day').add(this.minutes, 'minutes').format('LT');
            },
            report(rfid) {
                backend.reportWork({
                    'rfid': rfid
                })
                    .then((response) => {
                        this.username = response.data.username;
                        this.minutes = response.data.minutes;
                        this.started = response.data.started;
                    })
                    .catch((err) => {
                        this.$vs.notify({text: err.response.data.detail, color: 'danger', position: 'bottom-center'});
                    })
                    .then(() => {
                        setTimeout(this.reset, 2000);
                    });
            },
        },
    }
</script>

<style lang="css" scoped>
    @import '../../../node_modules/vuesax/dist/vuesax.css';
    @import '../../../node_modules/material-icons/iconfont/material-icons.css';

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s ease;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// RfidLogin.vue?04096c9a